// extracted by mini-css-extract-plugin
export var optionGrid = "_88-7";
export var optionList = "_88-6";
export var questionsBlock = "_88-9";
export var spacer = "_88-5";
export var stepCenteredContent = "_88-3";
export var stepInner = "_88-0";
export var stepInnerFullWidth = "_88-1";
export var stepInnerLockScroll = "_88-2";
export var stepTransitionFrame = "_88-4";
export var welcomeBlock = "_88-8";